export default function (rdv1, rdv2) {
    const result = rdvHourInMinutes(rdv2) - (rdvHourInMinutes(rdv1) + rdv1.duration);
    if (result >= 0) {
        return result;
    }
    else {
        return 0;
    }
}
const rdvHourInMinutes = (rdv) => rdv.hour * 60 + rdv.minute;
//# sourceMappingURL=findEmptySpaceBetweenRdvs.js.map